export default __webpack_public_path__ + "static/media/2000.b0574da0.png";